var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wx-open-btn-wrap" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "wx-open-launch-app",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLunchBtn,
              expression: "showLunchBtn",
            },
          ],
          ref: "btn",
          staticClass: "launch-btn",
          attrs: {
            appid: "wx9b913299215a38f2",
            extinfo: _vm.schema,
            path: _vm.schema,
          },
        },
        [
          _c("script", { attrs: { type: "text/wxtag-template" } }, [
            _vm._v(
              '\n      <style>\n        .btn{ width:100%;\n              height:100%;\n              border: 0;\n              outline: none;\n              opacity:0;\n              z-index:99;\n              position:absolute;\n              top:0;\n              left:0;\n              -webkit-tap-highlight-color:transparent !important\n              }</style>\n      <button class="btn"></button>\n    '
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }